/* eslint-disable no-undef */
import * as crypto from 'crypto';
const androidBrightest = async () => {
  try {
    if (typeof ez !== 'undefined' && ez.brightest) {
      await ez.brightest();
      return true;
    }
  } catch (error) {
    console.log('==androidBrightest error:', error);
  }
  return false;
};
const iosBrightest = async () => {
  try {
    if (typeof ezios !== 'undefined' && ezios.brightest) {
      await ezios.brightest;
      return true;
    }
  } catch (error) {
    console.log('==iosBrightest error:', error);
  }
  return false;
};

const brightest = async () => {
  console.log('==brightest 1');
  var result = await iosBrightest();
  // if (result) {
  //   result = await result;
  // }
  if (!result) {
    console.log('==brightest 2');
    result = await androidBrightest();
  }
  console.log('==brightest 3');
  return result;
};
const androidQrcam = async () => {
  try {
    if (typeof ez !== 'undefined' && ez.qrcam) {
      await ez.qrcam();
      return true;
    }
  } catch (error) {
    console.log('==androidQrcam error:', error);
  }
  return false;
};
const iosQrcam = async () => {
  try {
    if (typeof ezios !== 'undefined' && ezios.qrcam) {
      await ezios.qrcam;
      return true;
    }
  } catch (error) {
    console.log('==iosQrcam error:', error);
  }
  return false;
};

const qrcam = async () => {
  console.log('==qrcam 1');
  var result = await iosQrcam();
  // if (result) {
  //   result = await result;
  // }
  if (!result) {
    console.log('==qrcam 2');
    result = await androidQrcam();
  }
  console.log('==qrcam 3');
  return result;
};
const getAndroidToken = async () => {
  try {
    if (typeof ez !== 'undefined' && ez.getToken) {
      const token = await ez.getToken();
      return { os: 'android', token };
    }
  } catch (error) {
    console.log('==getAndroidToken error:', error);
  }
  return null;
};
const getIosToken = async () => {
  try {
    if (typeof ezios !== 'undefined' && ezios.getToken) {
      const token = await ezios.getToken;
      return { os: 'ios', token };
    }
  } catch (error) {
    console.log('==getIosToken error:', error);
  }
  return null;
};
const startActivity = async (sPackageName, sActivityName) => {
  try {
    if (ez && ez.startActivity) {
      console.log(`==呼叫安卓App ${sPackageName}`); //
      if (sActivityName) {
        ez.startActivityName(sPackageName, sActivityName);
      } else {
        ez.startActivity(sPackageName);
      }
    } else {
      console.log('非安卓或startActivity不存在');
    }
  } catch (error) {
    console.log('非安卓或startActivity不存在');
  }
};
const isAndroid = () => {
  try {
    const result = ez !== undefined && ez != null;
    console.log('==isAndroid:', result);
    return result;
  } catch (error) {
    return false;
  }
};
const isIos = () => {
  try {
    const result = ezios !== undefined && ezios != null;
    console.log('==isIos:', result);
    return result;
  } catch (error) {
    return false;
  }
};
const isApp = () => {
  return isAndroid() || isIos();
};
const getRand = (max) => {
  return Math.floor(Math.random() * Math.floor(max));
};
const getPageRand = () => {
  return getRand(100000);
};
const getIosTTSDisable = async () => {
  try {
    if (typeof ezios !== 'undefined' && ezios.ttsDisable) {
      const sttsDisable = await ezios.ttsDisable;
      // return { os: 'ios', ttsDisable };
      if (sttsDisable === 'true') {
        return true;
      }
      return false;
    }
    console.log('==getIosTTSDisable error:ezios is ', ezios);
    if (ezios) {
      console.log('ezios.ttsDisable is', ezios.ttsDisable);
    }
  } catch (error) {
    console.log('==getIosTTSDisable error: not ios', error);
    return false;
  }
  return false;
};
const setIosTTSDisable = (ttsDisable) => {
  try {
    console.log('==setIosTTSDisable to ', ttsDisable);
    if (typeof ezios !== 'undefined' && ezios.ttsDisableSetWithSDisable) {
      //參數sDisable，fun名稱會加上WithSDisable
      if (ttsDisable) {
        ezios.ttsDisableSetWithSDisable('true');
      } else {
        ezios.ttsDisableSetWithSDisable('false');
        // ezios.ttsEnableSet();
      }
    } else {
      console.log('==setIosTTSDisable error:ezios is ', ezios);
      if (ezios) {
        console.log(
          '==ezios.ttsDisableSetWithSDisable is',
          ezios.ttsDisableSetWithSDisable
        );
      }
    }
  } catch (error) {
    console.log('==setIosTTSDisable error: not ios', error);
  }
};

const isIphoneBrowser = () => {
  return /iPhone|iPod/.test(navigator.platform);
};
const isIpadBrowser = () => {
  return (
    /iPad/.test(navigator.platform) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  );
};
const isIosBrowser = () => {
  return (
    /iPad|iPhone|iPod/.test(navigator.platform) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  );
};

const reload = async () => {
  try {
    if (ez && ez.reload) {
      console.log('==呼叫安卓App reload'); //
      ez.reload();
    } else {
      console.log('安卓App reload不存在');
    }
  } catch (error) {
    console.log('安卓App reload發生錯誤');
  }
};
const pageReload = () => {
  window.location.reload();
  if (isAndroid()) {
    reload().then(() => {});
  }
};
function qrfun(str) {
  // const doc = document;
  try {
    if (!str) {
      console.log('==qrfun 沒有得到參數');
      return;
    }
    if (str[0] === '{' || str[0] === '[') {
      // obj
      const obj = JSON.parse(str);
      if (obj.ezexe) {
        // console.log('==exec:', obj.name, obj.value);
        // console.log('==do:', document);
        if (document[obj.ezexe]) {
          document[obj.ezexe](obj);
        } else {
          console.log('==document沒有註冊:', obj.ezexe);
        }
      } else {
        console.log('==qrfun 得到錯誤的JSON字串(必須有name=fun)：', str);
      }
    } else {
      // string
      console.log('==qrfun 得到不支援字串：', str);
    }
  } catch (error) {
    console.log('==qrfun error:', error);
  }
}
document.qrfun = qrfun; // 重要！註冊到document.qrfun

function qrcallback(callback) {
  document.qrcallback = callback;
}

function qrresult(str) {
  console.log('==qrcode:', str);
  if (document.qrcallback) {
    console.log('==呼叫qrcode callback');
    document.qrcallback(str);
  }
}
document.qrresult = qrresult;

const androidLoadPath = async (path) => {
  try {
    if (typeof ez !== 'undefined' && ez.loadPath) {
      await ez.loadPath(path);
    }
  } catch (error) {
    console.log('==loadPathAndroid got error:', error);
  }
};
const iosLoadPath = async (path) => {
  try {
    if (typeof ezios !== 'undefined' && ezios.loadWithPath) {
      //參數path，fun名稱會加上WithPath
      // console.log("==call spinSecIos",sec)
      await ezios.loadWithPath(`${path}`); // 用字串比較方便
    } else {
      console.log('==loadPathIos type error:', ezios);
    }
  } catch (error) {
    console.log('==loadPathIos got error:', error);
  }
};
const loadPath = (path) => {
  // console.log('==call spinSec', sec);
  iosLoadPath(path).then(() => {});
  androidLoadPath(path).then(() => {});
};

const getToken = async () => {
  // console.log('==getToken 1');
  var tok;
  var tokP = await getIosToken();
  if (tokP) {
    tok = tokP;
  }
  if (!tok) {
    // console.log('==getToken 2');
    tok = await getAndroidToken();
  }
  // console.log('==getToken 3');
  return tok;
};
let getHalfMd5 = (str) => {
  return crypto.createHash('md5').update(str).digest('hex').substr(16);
};

const androidShowpopup = async (url) => {
  try {
    if (typeof ez !== 'undefined' && ez.showpopup) {
      await ez.showpopup(url);
    }
  } catch (error) {
    console.log('==androidShowPopup got error:', error);
  }
};
const iosShowpopup = async (url) => {
  try {
    if (typeof ezios !== 'undefined' && ezios.showpopupWithUrl) {
      // console.log("==call spinSecIos",sec)
      await ezios.showpopupWithUrl(`${url}`); //參數url，fun名稱會加上WithUrl
    } else {
      console.log('==iosShowpopup type error:', ezios);
    }
  } catch (error) {
    console.log('==iosShowpopup got error:', error);
  }
};

const showpopup = (url) => {
  // console.log('==call spinSec', sec);
  iosShowpopup(url).then(() => {});
  androidShowpopup(url).then(() => {});
};

const androidHidepopup = async () => {
  try {
    if (typeof ez !== 'undefined' && ez.hidepopup) {
      await ez.hidepopup();
    }
  } catch (error) {
    console.log('==androidhidePopup got error:', error);
  }
};
const iosHidepopup = async () => {
  try {
    if (typeof ezios !== 'undefined' && ezios.hidepopup) {
      // console.log("==call spinSecIos",sec)
      await ezios.hidepopup(); // 用字串比較方便
    } else {
      console.log('==iosHidepopup type error:', ezios);
    }
  } catch (error) {
    console.log('==iosHidepopup got error:', error);
  }
};

const hidepopup = () => {
  // console.log('==call spinSec', sec);
  iosHidepopup().then(() => {});
  androidHidepopup().then(() => {});
};

const androidScanner = async (value) => {
  try {
    if (typeof ez !== 'undefined' && ez.codeScanner) {
      const androidScanner = await ez.codeScanner(value);
      return androidScanner;
    }
  } catch (error) {
    console.log('==androidScanner error:', error);
  }
  return false;
};
const iosScanner = async (value) => {
  try {
    const text = await webkit.messageHandlers.codeScanner.postMessage({
      type: value,
    });
    if (text) {
      return text;
    } else {
      if (typeof ezios !== 'undefined' && ezios.codeScanner) {
        const iosScanner = await ezios.codeScanner(value);

        return iosScanner;
      }
    }
  } catch (error) {
    console.log('==iosScanner error:', error);
  }
  return false;
};
export default {
  getToken,
  getAndroidToken,
  getIosToken,
  startActivity,
  isAndroid,
  isIos,
  isIosBrowser,
  isIphoneBrowser,
  isIpadBrowser,
  isApp,
  getRand,
  getPageRand,
  getIosTTSDisable,
  setIosTTSDisable,
  reload,
  pageReload,
  qrfun,
  getHalfMd5,
  androidLoadPath,
  iosLoadPath,
  loadPath,
  androidQrcam,
  iosQrcam,
  qrcam,
  qrcallback,
  qrresult,
  brightest,
  androidBrightest,
  iosBrightest,
  showpopup,
  hidepopup,
  androidScanner,
  iosScanner,
};
